export default __webpack_public_path__ + "static/media/head.7352f216.png";